import script from "./BaseTemplateLayers.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTemplateLayers.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTemplateLayers.vue?vue&type=style&index=0&id=69a0cf3d&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69a0cf3d"]])

export default __exports__